import React, { useState } from "react";
import { Button } from "react-bootstrap";
import ProductsLearnMoreModal from "./ProductsLearnMoreModal";

export default function ProductsBoomMail() {
  const [selectedProduct, setSelectedProduct] = useState(null);

  const handleLearnMoreClick = (event, product) => {
    event.preventDefault();
    event.stopPropagation();
    setSelectedProduct(product);
  };

  const handleCloseModal = () => {
    setSelectedProduct(null);
  };

  return (
    <div className="bg-page rounded-4 p-3 mb-5">
      <div className="text-center mb-4">
        <img
          src="/assets/products/images/mail.png"
          alt="BoomMail"
          className="img-fluid rounded-4"
          style={{ maxHeight: "280px", objectFit: "cover" }}
        />
        <div className="fw-bold text-navy text-center fs-2 mt-3">BoomMail</div>
      </div>

      <div>
        <p className="fs-5 mt-3">
          Are you working with corporate software restrictions, does you budget
          not stretch to 3rd party software solutions, is the requirement simply
          not big enough to warrant the investment, it’s no problem for boomMail
          as we can deliver SMS, Voice and other types of messaging capability
          straight into and out from your email client without the need to load
          software, train staff or even make changes to the way you already
          work.{" "}
        </p>
        <p className="fs-5 ">
          Working with legacy code or budgetary problems, too difficult to adopt
          new technology or have to many other pressing issues, Boommail is the
          Product for you.
        </p>
        <p className="fs-5 ">
          Using the existing infrastructure of email without the need to change
          anything, train anyone or code anything we can provide a clear and
          concise 2 x way messaging capability for staff to send and receive
          messages to and from the world. Used in conjunction with campaign this
          can help improve and fulfil stakeholder support with a better “on the
          move” solution and a follow the sun capability
        </p>
        <p className="fs-5 ">
          This can be integrated into ticketing systems and automated workflows
          even delivering a self-help capability.
        </p>
        <p className="fs-5 ">
          Look no further than boomMail for an off-the-shelf solution.{" "}
        </p>
      </div>

      <div className="text-center d-flex justify-content-center gap-3 mt-4">
        <Button
          className="bg-colored-reverse fw-bold border-0 rounded-3"
          onClick={(event) => handleLearnMoreClick(event, { name: "trial" })}
        >
          Free trial
        </Button>
        <Button
          className="bg-colored-reverse fw-bold border-0 rounded-3"
          onClick={(event) => handleLearnMoreClick(event, { name: "buy" })}
        >
          Buy
        </Button>
        <Button
          className="bg-colored-reverse fw-bold border-0 rounded-3"
          onClick={(event) =>
            handleLearnMoreClick(event, { name: "more information" })
          }
        >
          More Information
        </Button>
        <ProductsLearnMoreModal
          selectedProduct={selectedProduct}
          handleCloseModal={handleCloseModal}
        />
      </div>
    </div>
  );
}
